"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.OutlineManager = void 0;
const THREE = __importStar(require("three"));
class OutlineManager {
    // #endregion Properties (5)
    // #region Constructors (1)
    constructor(_renderingEngine) {
        this._renderingEngine = _renderingEngine;
        this._outlineNodes = [];
        this._separateObjects = false;
        this._perNodeEffects = new Map();
    }
    // #endregion Constructors (1)
    // #region Public Methods (8)
    addSelection(node) {
        var _a;
        this._outlineNodes.push(node);
        if (this._separateObjects) {
            (_a = this._onEffectsChanged) === null || _a === void 0 ? void 0 : _a.call(this);
        }
        else {
            this.updateOutlineEffectObjects();
        }
    }
    clearSelection() {
        var _a;
        this._outlineNodes = [];
        if (this._separateObjects) {
            this._perNodeEffects.clear();
            (_a = this._onEffectsChanged) === null || _a === void 0 ? void 0 : _a.call(this);
        }
        else {
            this.updateOutlineEffectObjects();
        }
    }
    /**
     * Called by PostProcessingManager during changeEffectPass to configure the
     * rendering mode and register the callback that rebuilds the effect pass
     * when the node selection changes.
     */
    configure(separateObjects, onEffectsChanged) {
        this._separateObjects = separateObjects;
        this._onEffectsChanged = onEffectsChanged;
        this._perNodeEffects.clear();
    }
    removeSelection(node) {
        var _a;
        const index = this._outlineNodes.indexOf(node);
        if (index !== -1) {
            this._outlineNodes.splice(index, 1);
            if (this._separateObjects) {
                this._perNodeEffects.delete(node);
                (_a = this._onEffectsChanged) === null || _a === void 0 ? void 0 : _a.call(this);
            }
            else {
                this.updateOutlineEffectObjects();
            }
            return true;
        }
        return false;
    }
    /** Used in the default grouped mode. */
    setEffect(outlineEffect) {
        this._outlineEffect = outlineEffect;
        this.updateOutlineEffectObjects();
    }
    /**
     * Used in separateObjects mode. PostProcessingManager passes a fresh
     * per-node map each time it rebuilds the effect pass.
     */
    setPerNodeEffects(effects) {
        this._perNodeEffects = effects;
        this.updateOutlineEffectObjects();
    }
    updateOutlineEffectObjects() {
        if (this._separateObjects) {
            for (const [node, effect] of this._perNodeEffects) {
                effect.selection.clear();
                const object = node.convertedObject[this._renderingEngine.id];
                if (!object)
                    continue;
                object.traverse((o) => {
                    if (o instanceof THREE.Mesh)
                        effect.selection.add(o);
                });
            }
        }
        else {
            if (!this._outlineEffect)
                return;
            this._outlineEffect.selection.clear();
            const objects = [];
            for (let i = 0; i < this._outlineNodes.length; i++) {
                const object = this._outlineNodes[i].convertedObject[this._renderingEngine.id];
                if (!object)
                    continue;
                object.traverse((o) => {
                    if (o instanceof THREE.Mesh)
                        objects.push(o);
                });
            }
            this._outlineEffect.selection.set(objects);
        }
    }
    selectedNodes() {
        return this._outlineNodes;
    }
}
exports.OutlineManager = OutlineManager;
//# sourceMappingURL=OutlineManager.js.map